import { useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { useAtom } from 'jotai';
import { accountUsersService } from '@/services/account-users.service';
import { selectedAccountIdAtom } from '@/hooks/use-account';
import { queryClient } from '@/lib/query-client';
import type { AddUserDto } from '@/types';

const accountUsersQueryAtom = atomWithQuery((get) => {
  const id = get(selectedAccountIdAtom);
  return {
    queryKey: ['account-users', id],
    enabled: id != null,
    queryFn: () => accountUsersService.list(id as number)
  };
});

export const useAccountUsers = () => {
  const [result] = useAtom(accountUsersQueryAtom);
  return result;
};

export const useAccountUserMutations = () => {
  const id = useAtomValue(selectedAccountIdAtom);

  const requireId = (): number => {
    if (id == null) throw new Error('No account selected');
    return id;
  };
  const refresh = (accountId: number) =>
    queryClient.invalidateQueries({ queryKey: ['account-users', accountId] });

  return {
    addUser: async (payload: AddUserDto) => {
      const accountId = requireId();
      const res = await accountUsersService.add(accountId, payload);
      await refresh(accountId);
      return res;
    },
    setRole: async (userId: number, role: number) => {
      const accountId = requireId();
      const res = await accountUsersService.setRole(accountId, userId, role);
      await refresh(accountId);
      return res;
    },
    removeUser: async (userId: number) => {
      const accountId = requireId();
      const res = await accountUsersService.remove(accountId, userId);
      await refresh(accountId);
      return res;
    }
  };
};
